module.exports = __webpack_public_path__ + "static/media/yiliao_geren_icon@3x.eed8b524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yiliao_geren_icon@3x.png
// module id = 672
// module chunks = 0